import { render, staticRenderFns } from "./ImportRequest.vue?vue&type=template&id=02497ad1"
import script from "./ImportRequest.vue?vue&type=script&lang=js"
export * from "./ImportRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports